import PropTypes from 'prop-types';
import { Box, Link, Typography } from '@okta/odyssey-react-mui';
import { useLabContext } from '../../LabContext';
import { useTranslation } from 'react-i18next';

const AssetsTab = ({ event }) => {
  const { t } = useTranslation('events');
  const labContext = useLabContext();
  const lab = labContext.labs?.find((l) => l.id === event.labContent);
  const assets = lab?.assets || [];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2.14285714rem' }}>
      <Box>
        {lab ? (
          <>
            <Typography variant="h4" gutterBottom>
              {t('labDetails-assets-heading')} {lab.title}
            </Typography>
            {assets.length > 0 ? (
              <Box sx={{ pl: 3 }}>
                {assets.map((asset) => (
                  <Box key={asset.uri}>
                    <Typography variant="legend"><Link href={asset.uri} target="_blank">{asset.title}</Link></Typography>
                    <Typography variant="support">{asset.description}</Typography>
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography variant="body2">{t('event-table-empty-state-text')}</Typography>
            )}
          </>
        ) : (
          <>
            <Typography variant="h3" gutterBottom>
              {t('labDetails-assets-title')}
            </Typography>
            <Typography>{t('labDetails-no-assets-found')}</Typography>
          </>
        )}
      </Box>

        <Box sx={{display:'flex', flexDirection:'column', gap:'1rem'}}>
            <Box sx={{display:'flex', flexDirection:'column', gap:'0.75rem'}}>
                <Typography variant='h3'>{t('before-event-heading')}</Typography>
                <Typography variant='legend'>{t('staff-the-event-heading')}</Typography>
                <Typography variant='body'>{t('staff-the-event')}</Typography>
                <Typography variant='body'>{t('report-errors-instruction')}</Typography>
                <Typography variant='legend'>{t('grant-access-title')}</Typography>
                <Typography variant='body'>{t('grant-access-description') }<Link target='_blank' uri="https://demo.okta.com/guest">{t('guest-management-link-text')}</Link></Typography>
            </Box>

            <Box sx={{display:'flex', flexDirection:'column', gap:'0.75rem'}}>
                <Typography variant='h3'>{t('during-event-heading')}</Typography>
                <Typography variant='legend'>{t('launch-event-title')}</Typography>
                <Typography>{t('launch-event-intro')}</Typography>
                <Typography variant='body'>{t('launch-event-code')}<Link uri={`${window.location.host}/${event.eventCode}`} target='_blank'> {`${window.location.host}/${event.eventCode}`}</Link></Typography>
                <Typography variant='body'>{t('launch-event-recommendation')}</Typography>
                <Typography variant='body'>{t('launch-event-authentication-flow')}</Typography>

                <Typography variant='legend'>{t('track-progress-title')}</Typography>
                <Typography variant='body'>{t('track-progress-description')}</Typography>
                <Typography variant='body'>{t('request-help-description')}</Typography>
            </Box>
        </Box>
    </Box>
  );
};

AssetsTab.propTypes = {
  event: PropTypes.shape({
    labContent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

export default AssetsTab;